export const Logo = ({ muted = false, size = 'default' }) => {
  const barColor = muted ? '#6B7280' : '#ffffff';
  const blueBar = '#3b82f6';
  
  const sizeClasses = {
    small: 'w-8 h-8',
    default: 'w-10 h-10',
    large: 'w-12 h-12',
  };

  return (
    <svg 
      viewBox="0 0 80 76" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={sizeClasses[size]}
      aria-label="Veranda AI Logo"
    >
      <rect x="0" y="0" width="24" height="10" rx="1.5" fill={barColor}/>
      <rect x="56" y="0" width="24" height="10" rx="1.5" fill={barColor}/>
      <rect x="8" y="16" width="24" height="10" rx="1.5" fill={barColor}/>
      <rect x="48" y="16" width="24" height="10" rx="1.5" fill={barColor}/>
      <rect x="16" y="32" width="20" height="10" rx="1.5" fill={barColor}/>
      <rect x="44" y="32" width="20" height="10" rx="1.5" fill={barColor}/>
      <rect x="22" y="48" width="16" height="10" rx="1.5" fill={barColor}/>
      <rect x="42" y="48" width="16" height="10" rx="1.5" fill={barColor}/>
      <rect x="30" y="64" width="20" height="10" rx="1.5" fill={blueBar}/>
    </svg>
  );
};

export default Logo;
